import { Component, OnInit, Input } from '@angular/core';

import { Alert, AlertType } from './alert';
import { AlertService } from './alert.service';


@Component({
    selector: 'alert',
    templateUrl: 'alert.component.html',
    styleUrls: ['./alert.component.scss'],
})


export class AlertComponent {

    @Input() id: string;

    alerts: Alert[] = [];

    errorAlertFlag: boolean = false;

    alertStyle: string;
    alertIconMaterial: string;

    constructor(private alertService: AlertService) {  }

    ngOnInit() {
        this.alertService.getAlert(this.id).subscribe((alert: Alert) => {
            if (!alert.message) {
                this.alerts = [];
                return;
            }
            this.setAlertStyle(alert);
            if(alert.type == AlertType.Error){
                this.errorAlertFlag = true;
                this.alerts = [alert]
            }else{
                this.alerts.push(alert); 
            }
        });
    }

    removeAlert(alert: Alert) {
        this.errorAlertFlag = false;
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    setAlertStyle(alert: Alert) {

        switch (alert.type) {
            case AlertType.Success:
                this.alertStyle = 'successAlert'; 
                this.alertIconMaterial = 'fas fa-check-circle';
                break;
            case AlertType.Error:
                this.alertStyle = 'errorAlert'; 
                this.alertIconMaterial =  'fas fa-times-circle';
                break;
            case AlertType.Info:
                this.alertStyle = 'infoAlert'; 
                this.alertIconMaterial =  'fas fa-info-circle';
                break;
            case AlertType.Warning:
                this.alertStyle = 'warningAlert'; 
                this.alertIconMaterial =  'fas fa-exclamation-triangle';
                break;
        }
    }

    resetAlerts(){
        this.errorAlertFlag = false;
        this.alerts = [];
    }

    reloadPage(){
        top.window.location.reload();
    }
}